import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  user: sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')) : null,
  userToken: sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '',
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setCredentials: (state, action) => {
      state.user = action.payload.user
      state.userToken = action.payload.token
      sessionStorage.setItem('user', JSON.stringify(action.payload.user))
      sessionStorage.setItem('token', action.payload.token)
    },
    logOut: (state, action) => {
      state.user = null
      state.userToken = ''
      sessionStorage.clear()

      // Define a condition to identify keys to keep (e.g., keys that start with "activities_")
      const keysToKeep = Object.keys(localStorage).filter((key) => key.startsWith('activities_'))

      // Save the items you want to keep in a temporary object
      const savedItems = {}
      keysToKeep.forEach((key) => {
        const item = localStorage.getItem(key)
        if (item !== null) {
          savedItems[key] = item
        }
      })

      // Clear all of localStorage
      localStorage.clear()

      // Restore the saved items
      Object.entries(savedItems).forEach(([key, value]) => {
        localStorage.setItem(key, value)
      })
    },
  },
})

// Action creators are generated for each case reducer function
export const { setCredentials, logOut } = authSlice.actions

export default authSlice.reducer
